// extracted by mini-css-extract-plugin
export var trailingIconStyle = "input_trailing_icon-module--trailingIconStyle--6jdvd";